<template>
    <b-nav tabs>
        <b-nav-item :to="route" v-for="route in routerLinks" :key="route.name" active-class="active">
            {{ pages[route.name].title }}
        </b-nav-item>
    </b-nav>
</template>

<script>

import pages from '@/routing/pages.js';

export default {
    data() {
        return {
            pages
        }
    },

    props: ['routes'],

    computed: {
        routerLinks() {
            const routerLinks = this.routes.map((routeName) => {
                return {
                    name: routeName,
                }
            });

            return routerLinks;
        }
    },
}

</script>
